import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { dayTheme, nightTheme } from './micuTheme';

const STORAGE_KEY = 'micu-color-mode';

const MICUThemeContext = createContext(null);

export const useMICUTheme = () => {
  const ctx = useContext(MICUThemeContext);
  if (!ctx) throw new Error('useMICUTheme must be used within MICUThemeProvider');
  return ctx;
};

const MICUThemeProvider = ({ children }) => {
  const [mode, setMode] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || 'night';
    } catch {
      return 'night';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch { /* noop */ }
  }, [mode]);

  const toggleMode = useCallback(() => {
    setMode(prev => prev === 'day' ? 'night' : 'day');
  }, []);

  const isDark = mode === 'night';
  const theme = isDark ? nightTheme : dayTheme;

  return (
    <MICUThemeContext.Provider value={{ mode, toggleMode, isDark }}>
      <ChakraProvider theme={theme} resetCSS>
        {children}
      </ChakraProvider>
    </MICUThemeContext.Provider>
  );
};

export default MICUThemeProvider;
